/**
 * DO NOT EDIT THIS FILE MANUALLY
 * Generated by `Opus::GeneratedFileVerifier::Generators::DashboardData::DashboardDataTSStep`
 * If this file is out-of-sync or causing builds to fail, try running `scripts/bin/sync-generated`
 */
export interface DebitCardCountryData {
  readonly currency: string;
  readonly test_token: string;
};

export interface DebitCardCountrySupportMap {
  readonly [key: string]: DebitCardCountryData;
};

export const expressDebitCardSupportMap: DebitCardCountrySupportMap = {
  "AU": {
    "currency": "aud",
    "test_token": "tok_visa_debit_au_transferSuccess"
  },
  "CA": {
    "currency": "cad",
    "test_token": "tok_visa_debit_ca_transferSuccess"
  },
  "SG": {
    "currency": "sgd",
    "test_token": "tok_visa_debit_sg_transferSuccess"
  },
  "US": {
    "currency": "usd",
    "test_token": "tok_visa_debit_us_transferSuccess"
  }
};

export const expressDebitCardBetaSupportMap: DebitCardCountrySupportMap = {
  "GB": {
    "currency": "gbp",
    "test_token": "tok_visa_debit_gb_transferSuccess"
  },
  "NZ": {
    "currency": "nzd",
    "test_token": "tok_visa_debit_nz_transferSuccess"
  },
  "AT": {
    "currency": "eur",
    "test_token": "tok_visa_debit_at_transferSuccess"
  },
  "BE": {
    "currency": "eur",
    "test_token": "tok_visa_debit_be_transferSuccess"
  },
  "HR": {
    "currency": "eur",
    "test_token": "tok_visa_debit_hr_transferSuccess"
  },
  "CY": {
    "currency": "eur",
    "test_token": "tok_visa_debit_cy_transferSuccess"
  },
  "EE": {
    "currency": "eur",
    "test_token": "tok_visa_debit_ee_transferSuccess"
  },
  "FI": {
    "currency": "eur",
    "test_token": "tok_visa_debit_fi_transferSuccess"
  },
  "FR": {
    "currency": "eur",
    "test_token": "tok_visa_debit_fr_transferSuccess"
  },
  "DE": {
    "currency": "eur",
    "test_token": "tok_visa_debit_de_transferSuccess"
  },
  "GR": {
    "currency": "eur",
    "test_token": "tok_visa_debit_gr_transferSuccess"
  },
  "IE": {
    "currency": "eur",
    "test_token": "tok_visa_debit_ie_transferSuccess"
  },
  "IT": {
    "currency": "eur",
    "test_token": "tok_visa_debit_it_transferSuccess"
  },
  "LV": {
    "currency": "eur",
    "test_token": "tok_visa_debit_lv_transferSuccess"
  },
  "LT": {
    "currency": "eur",
    "test_token": "tok_visa_debit_lt_transferSuccess"
  },
  "LU": {
    "currency": "eur",
    "test_token": "tok_visa_debit_lu_transferSuccess"
  },
  "MT": {
    "currency": "eur",
    "test_token": "tok_visa_debit_mt_transferSuccess"
  },
  "NL": {
    "currency": "eur",
    "test_token": "tok_visa_debit_nl_transferSuccess"
  },
  "PT": {
    "currency": "eur",
    "test_token": "tok_visa_debit_pt_transferSuccess"
  },
  "SK": {
    "currency": "eur",
    "test_token": "tok_visa_debit_sk_transferSuccess"
  },
  "SI": {
    "currency": "eur",
    "test_token": "tok_visa_debit_si_transferSuccess"
  },
  "ES": {
    "currency": "eur",
    "test_token": "tok_visa_debit_es_transferSuccess"
  },
  "NO": {
    "currency": "nok",
    "test_token": "tok_visa_debit_no_transferSuccess"
  },
  "SE": {
    "currency": "sek",
    "test_token": "tok_visa_debit_se_transferSuccess"
  },
  "DK": {
    "currency": "dkk",
    "test_token": "tok_visa_debit_dk_transferSuccess"
  },
  "PL": {
    "currency": "pln",
    "test_token": "tok_visa_debit_pl_transferSuccess"
  },
  "CZ": {
    "currency": "czk",
    "test_token": "tok_visa_debit_cz_transferSuccess"
  },
  "RO": {
    "currency": "ron",
    "test_token": "tok_visa_debit_ro_transferSuccess"
  },
  "HU": {
    "currency": "huf",
    "test_token": "tok_visa_debit_hu_transferSuccess"
  }
};
